//@import pages
import BannerScreen from 'app_components/screens/admin/banner'
import CompanyScreen from 'app_components/screens/admin/company'
import CourseScreen from 'app_components/screens/admin/course'
import CourseSchedulingScreen from 'app_components/screens/admin/courseScheduling'
import CourseSchedulingDetailsScreen from 'app_components/screens/admin/courseSchedulingDetails'
import CourseSchedulingEnrollmentScreen from 'app_components/screens/admin/courseSchedulingEnrollment'
import DocumentProcessorScreen from 'app_components/screens/admin/documentProcessor'
import ForumScreen from 'app_components/screens/admin/forum'
import BusinessLandingScreen from 'app_components/screens/admin/landings/businessLanding'
import ListLandingsScreen from 'app_components/screens/admin/landings/listLandings'
import OfficialsLandingScreen from 'app_components/screens/admin/landings/officialsLanding/index'
import StudentLandingScreen from 'app_components/screens/admin/landings/studentLanding/index'
import AlliancesLandingScreen from 'app_components/screens/admin/landings/alliancesLanding/index'
import TeacherLandingScreen from 'app_components/screens/admin/landings/teacherLanding'
import ModularScreen from 'app_components/screens/admin/modular'
import PortfolioScreen from 'app_components/screens/admin/PortfolioScreen/PortfolioScreen'
import PostScreen from 'app_components/screens/admin/post'
import ReportsScreen from 'app_components/screens/admin/reports/index'
import RoleScreen from 'app_components/screens/admin/role'
import StudentAdministratorScreen from 'app_components/screens/admin/studentAdministrator/index'
import UserScreen from 'app_components/screens/admin/user'
import CreatesurveyScreen from 'app_components/screens/editor/createsurvey/index'
import EditorlistScreen from 'app_components/screens/editor/editorlist/index'
import HomeScreen from 'app_components/screens/home'
import LoginScreen from 'app_components/screens/login'
import ProfileScreen from 'app_components/screens/profile'
import QualifiedTeacherScreen from 'app_components/screens/qualifiedTeacher'
import RegisterScreen from 'app_components/screens/register/RegisterScreen'
import TutorialsLanding from 'app_components/modules/admin/landings/tutorialsLandingAdmin/TutorialsLandingAdmin'
import TutorialsPrivatePage from 'app_components/screens/admin/TutorialsPrivatePage/TutorialsPrivatePage'
import CertificateSettings from 'app_components/screens/admin/CertificateSettings/CertificateSettings'
import CertificateCriteria from 'app_components/screens/admin/CertificateCriteria/CertificateCriteria'
import CertificateCriteriaForm from 'app_components/screens/admin/CertificateCriteria/components/CertificateCriteriaForm/CertificateCriteriaForm'
//@end

// @import types
import { IRouteApp } from 'app_types/routes/routes.types'
import { UserFormInputs } from 'app_types/admin/user/userTypes'
import FilterCreationScreen from 'app_components/screens/admin/course/components/FilterCreationScreen/FilterCreationScreen'
import HomeLandingAdmin from 'app_components/screens/admin/landings/HomeLandingAdmin/HomeLandingAdmin'
import TermsAndConditionsLanding from 'app_components/screens/admin/landings/termsAndConditionsLanding/TermsAndConditionsLanding'
import PurchasedItems from 'app_components/screens/purchasedItems/PurchasedItems'
// @end


export const routes: IRouteApp[] = [
  {
    path: '/login',
    exact: true,
    component: LoginScreen,
  },
  {
    path: '/register',
    exact: true,
    component: RegisterScreen,
  },
  {
    path: '/',
    exact: true,
    component: HomeScreen,
    isSecure: true,
  },
  {
    path: '/profile',
    exact: true,
    component: ProfileScreen,
    isSecure: true,
  },
  {
    path: '/admin/landings',
    exact: true,
    component: ListLandingsScreen,
    isSecure: true,
  },
  {
    path: '/admin/landings/teacher',
    exact: true,
    component: TeacherLandingScreen,
    isSecure: true,
  },
  {
    path: '/admin/landings/business',
    exact: true,
    component: BusinessLandingScreen,
    isSecure: true,
  },
  {
    path: '/admin/landings/officials',
    exact: true,
    component: OfficialsLandingScreen,
    isSecure: true,
  },
  {
    path: '/admin/landings/students',
    exact: true,
    component: StudentLandingScreen,
    isSecure: true,
  },
  {
    path: '/admin/landings/alliances',
    exact: true,
    component: AlliancesLandingScreen,
    isSecure: true,
  },
  {
    path: '/admin/landings/tutorials',
    exact: true,
    component: TutorialsLanding,
    isSecure: true,
  },
  {
    path: '/admin/landings/home',
    exact: true,
    component: HomeLandingAdmin,
    isSecure: true,
  },
  {
    path: '/admin/landings/terms-and-conditions',
    exact: true,
    component: TermsAndConditionsLanding,
    isSecure: true,
  },
  {
    path: '/admin/users',
    exact: true,
    component: UserScreen,
    isSecure: true,
  },
  {
    path: '/admin/account-executive',
    exact: true,
    component: UserScreen,
    isSecure: true,
    customs: {
      role: 'account_executive',
      show_inputs: [
        UserFormInputs.FIRST_NAME,
        UserFormInputs.LAST_NAME,
        UserFormInputs.USERNAME,
        UserFormInputs.EMAIL,
        UserFormInputs.PHONE_NUMBER,
        UserFormInputs.DOC_NUMBER,
        UserFormInputs.DOC_TYPE,
        UserFormInputs.PASSWORD,
        UserFormInputs.TIMEZONE,
        UserFormInputs.DIALECT,
        UserFormInputs.ROLES,
      ],
      editabled_inputs: [
        UserFormInputs.FIRST_NAME,
        UserFormInputs.LAST_NAME,
        UserFormInputs.EMAIL,
        UserFormInputs.PHONE_NUMBER,
        UserFormInputs.DOC_TYPE,
        UserFormInputs.PASSWORD,
        UserFormInputs.TIMEZONE,
        UserFormInputs.DIALECT,
        UserFormInputs.ROLES,
      ]
    },
  },
  {
    path: '/admin/students',
    exact: true,
    component: UserScreen,
    isSecure: true,
    customs: {
      role: 'student',
      show_inputs: [
        UserFormInputs.FIRST_NAME,
        UserFormInputs.LAST_NAME,
        UserFormInputs.USERNAME,
        UserFormInputs.EMAIL,
        UserFormInputs.PHONE_NUMBER,
        UserFormInputs.DOC_NUMBER,
        UserFormInputs.DOC_TYPE,
        UserFormInputs.PASSWORD,
        UserFormInputs.TIMEZONE,
        UserFormInputs.DIALECT,
        UserFormInputs.ROLES,
      ],
      editabled_inputs: [
        UserFormInputs.FIRST_NAME,
        UserFormInputs.LAST_NAME,
        UserFormInputs.EMAIL,
        UserFormInputs.PHONE_NUMBER,
        UserFormInputs.DOC_TYPE,
        UserFormInputs.PASSWORD,
      ]
    },
  },
  {
    path: '/admin/company-collaborator',
    exact: true,
    component: UserScreen,
    isSecure: true,
    customs: {
      role: 'company_collaborator',
      show_inputs: [
        UserFormInputs.FIRST_NAME,
        UserFormInputs.LAST_NAME,
        UserFormInputs.USERNAME,
        UserFormInputs.EMAIL,
        UserFormInputs.PHONE_NUMBER,
        UserFormInputs.DOC_NUMBER,
        UserFormInputs.DOC_TYPE,
        UserFormInputs.PASSWORD,
        UserFormInputs.TIMEZONE,
        UserFormInputs.DIALECT,
        UserFormInputs.ROLES,
      ],
      editabled_inputs: [
        UserFormInputs.FIRST_NAME,
        UserFormInputs.LAST_NAME,
        UserFormInputs.EMAIL,
        UserFormInputs.PHONE_NUMBER,
        UserFormInputs.DOC_TYPE,
        UserFormInputs.PASSWORD,
        UserFormInputs.TIMEZONE,
        UserFormInputs.DIALECT,
        UserFormInputs.ROLES,
      ]
    },
  },
  {
    path: '/admin/qualifiedTeacher',
    exact: true,
    component: QualifiedTeacherScreen,
    isSecure: true,
  },
  {
    path: '/admin/portfolio',
    exact: true,
    component: PortfolioScreen,
    isSecure: true,
  },
  {
    path: '/admin/document-processor/:document_type?',
    exact: true,
    component: DocumentProcessorScreen,
    isSecure: true,
  },
  {
    path: '/admin/roles',
    exact: true,
    component: RoleScreen,
    isSecure: true,
  },
  {
    path: '/admin/posts',
    exact: true,
    component: PostScreen,
    isSecure: true,
  },
  {
    path: '/admin/companies',
    exact: true,
    component: CompanyScreen,
    isSecure: true,
  },
  {
    path: '/admin/forums',
    exact: true,
    component: ForumScreen,
    isSecure: true,
  },
  {
    path: '/admin/banners',
    exact: true,
    component: BannerScreen,
    isSecure: true,
  },
  {
    path: '/admin/courses',
    exact: true,
    component: CourseScreen,
    isSecure: true,
  },
  {
    path: '/admin/course-scheduling',
    exact: true,
    component: CourseSchedulingScreen,
    isSecure: true,
  },
  {
    path: '/admin/course-scheduling/:course_scheduling',
    exact: true,
    component: CourseSchedulingDetailsScreen,
    isSecure: true,
  },
  {
    path: '/admin/course-scheduling-participants/:course_scheduling',
    exact: true,
    component: CourseSchedulingEnrollmentScreen,
    isSecure: true,
  },
  {
    path: '/admin/modulars',
    exact: true,
    component: ModularScreen,
    isSecure: true,
  },
  {
    path: '/survey-list',
    component: EditorlistScreen,
    isSecure: true,
    exact: true,
  },
  {
    path: '/create_survey',
    component: CreatesurveyScreen,
    isSecure: true,
    exact: true,
  },
  {
    path: '/admin/student-administrator',
    component: StudentAdministratorScreen,
    isSecure: true,
    exact: true,
  },
  {
    path: '/admin/reports',
    component: ReportsScreen,
    isSecure: true,
    exact: true,
  },
  {
    path: '/tutorials',
    component: TutorialsPrivatePage,
    isSecure: true,
    exact: true,
  },
  {
    path: '/admin/certificate-settings/:courseSchedulingId',
    component: CertificateSettings,
    isSecure: true,
    exact: true,
  },
  {
    path: '/admin/certificate-criteria',
    component: CertificateCriteria,
    isSecure: true,
    exact: true,
  },
  {
    path: '/admin/certificate-criteria/:certificateCriteriaId',
    component: CertificateCriteriaForm,
    isSecure: true,
    exact: true,
  },
  {
    path: '/admin/courses/filter/:termId',
    component: FilterCreationScreen,
    isSecure: true,
    exact: true,
  },
  {
    path: '/my-products',
    component: PurchasedItems,
    isSecure: true,
    exact: true
  }
]
